import { useMemo, useState } from 'react';
import { sendChatMessage } from '../services/chat';
import MessageList from './MessageList';
import ChatSearchBar from './ChatSearchBar';
import { useAuth } from '../context/AuthContext';

const ChatPanel = () => {
  const [messages, setMessages] = useState([]);
  const [conversationId, setConversationId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [input, setInput] = useState('');
  const { accessToken } = useAuth();

  const pushMessage = (msg) => {
    setMessages((prev) => [...prev, { id: crypto.randomUUID(), ...msg }]);
  };

  const handleSend = async (text) => {
    if (!text || isLoading) return;
    setError(null);
    pushMessage({ role: 'user', content: text });
    setIsLoading(true);
    try {
      const res = await sendChatMessage({ message: text, conversationId, accessToken });
      // eslint-disable-next-line no-console
      console.log('Chat response:', res);
      setConversationId((prev) => prev || res.conversation_id || null);
      pushMessage({
        role: 'assistant',
        content: res.message || '',
        type: res.type,
        options: res.options,
      });
    } catch (err) {
      console.error(err);
      const msg = err.message || 'Failed to fetch';
      pushMessage({ role: 'assistant', content: msg, type: 'error' });
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectOption = async (label) => {
    await handleSend(label);
  };

  const placeholderMessage = useMemo(() => (messages.length === 0 ? [] : []), [messages.length]);

  return (
    <div className="flex h-full min-h-0 w-full flex-1 flex-col gap-4">
      <div className="flex items-center justify-end px-1">
        {isLoading ? (
          <div className="flex items-center gap-2 text-xs text-slate-500 dark:text-slate-300">
            <span className="inline-block h-2 w-2 animate-ping rounded-full bg-sky-400" />
            Thinking…
          </div>
        ) : null}
      </div>

      <div className="flex-1 min-h-0 flex flex-col gap-4 px-0 md:px-1 overflow-hidden">
        <div className="flex-1 min-h-0 overflow-y-auto pr-1 pb-32">
          <MessageList messages={[...placeholderMessage, ...messages]} onSelectOption={handleSelectOption} isBusy={isLoading} />
        </div>
      </div>

      <div className="sticky bottom-0 z-50 w-full bg-[#050815] border-t border-white/5 pt-3">
        <ChatSearchBar
          value={input}
          onChange={(val) => {
            if (error) setError(null);
            setInput(val);
          }}
          onSubmit={() => {
            handleSend(input.trim());
            setInput('');
          }}
          disabled={isLoading}
          tags={[]}
          placeholder="Ask me anything about your relationships..."
        />
      </div>
    </div>
  );
};

export default ChatPanel;
